import { useMutation } from "@tanstack/react-query";
import { api } from "../../utils";

export const useFetchApplePayData = () =>
  useMutation(() => api.get("/apple_pay/new_merchant_session"));
